module.exports = __webpack_public_path__ + "static/scale-model-of-language-of-the-birds-in-san-francisco-california-8eb47b56c00357c6cd20885e60dd75d0.png";